import { render, staticRenderFns } from "./SearchResultTicketItem.vue?vue&type=template&id=afed0812&scoped=true&"
import script from "./SearchResultTicketItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultTicketItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultTicketItem.vue?vue&type=style&index=0&id=afed0812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afed0812",
  null
  
)

export default component.exports